'use client'

import Section from 'components/Section'
import { Typography, MediaImageStandard } from 'components/Contentful'

const createImageContent = (src) => ({
  fields: {
    file: {
      url: src,
      fileName: 'grow-your-business-icon',
    },
  },
})

function GrowYourBusiness(content) {
  const jsonContent =
    content?.content?.fields?.sectionContents?.find(
      (section) => section?.fields?.uiComponent === 'JsonContent'
    )?.fields?.jsonContent ||
    content?.content?.jsonContent ||
    content?.jsonContent

  if (!jsonContent) return null

  const { title, subtitle, cards } = jsonContent

  return (
    <Section
      disableGutters
      maxWidth={false}
      className="pt-[48px] breakpointMd:pt-[80px] pb-[48px] breakpointMd:pb-[80px] breakpointMd:px-[32px]"
    >
      <div className="grid grid-cols-4 breakpointMd:grid-cols-6 breakpointLg:grid-cols-12 gap-x-4 gap-y-0 breakpointMd:gap-x-6 breakpointLg:gap-x-8 pt-[48px] breakpointMd:pt-[64px] pb-[48px] breakpointMd:pb-[64px] bg-[#2C47F6] rounded-[32px] breakpointLg:max-w-[1216px] breakpointLg:mx-auto">
        {title && (
          <Typography
            content={title}
            className="col-span-full breakpointLg:col-start-3 breakpointLg:col-end-11 flex flex-col items-center gap-[16px] font-ultramarine text-[40px] breakpointMd:text-[52px] font-bold leading-[120%] text-[#F8F9FC] text-center px-[20px] breakpointMd:px-[32px] breakpointLg:px-0 line-clamp-4 breakpointMd:line-clamp-3 text-pretty"
          />
        )}
        {subtitle && (
          <Typography
            content={subtitle}
            className="col-span-full breakpointLg:col-start-3 breakpointLg:col-end-11 font-ultramarine text-[16px] breakpointMd:text-[18px] font-normal leading-[140%] text-[#F8F9FC] text-center mt-[16px] px-[20px] breakpointMd:px-[32px] breakpointLg:px-0 line-clamp-4 breakpointMd:line-clamp-3 text-pretty"
          />
        )}
        {cards && cards.length > 0 && (
          <div className="col-span-full breakpointLg:col-start-2 breakpointLg:col-end-12 mt-[32px] breakpointMd:mt-[48px] px-[20px] breakpointMd:px-[32px] breakpointLg:px-0 grid grid-cols-1 gap-y-[24px] breakpointLg:grid-cols-3 breakpointLg:gap-x-[32px]">
            {cards.slice(0, 3).map((card, index) => (
              <div
                key={`grow-card-${index}`}
                className="rounded-[16px] bg-white px-[32px] py-[32px] flex flex-col items-start text-left"
              >
                {card?.icon && (
                  <div className="w-[50px] h-[50px] shrink-0 overflow-hidden">
                    <MediaImageStandard
                      content={createImageContent(card.icon)}
                      alt={card?.title || 'card icon'}
                      width={50}
                      height={50}
                      className="w-full h-full object-contain"
                    />
                  </div>
                )}
                {card?.title && (
                  <Typography
                    content={card.title}
                    className="mt-[16px] font-ultramarine text-[20px] font-bold leading-[120%] text-[#1D252F] line-clamp-3 text-pretty"
                  />
                )}
                {card?.description && (
                  <Typography
                    content={card.description}
                    className="mt-[8px] font-ultramarine text-[16px] font-normal leading-[140%] text-[#1D252F] line-clamp-6 text-pretty"
                  />
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </Section>
  )
}

export default GrowYourBusiness
